const Get_users_success = "Get_users_s";
const Get_users_req = "Get_users_req";
const Get_users_error = "Get_users_error";
export {
  Get_users_error,
  Get_users_req,
  Get_users_success,
};
